import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexBox, ImgWrap } from "../../styles/Common";
import arrow from "../../styles/images/ico_arrow_down.svg";
import { ReactComponent as IcoFile } from "../../styles/images/ico_notice_file.svg";
import { checkMobile, timeChange } from "../hooks/basicFunc";
import { useDispatch } from "react-redux";
import { serviceActions } from "../../store/slices/serviceSlice";
import { ContentState, Editor, EditorState, convertFromHTML } from "draft-js";
import "draft-js/dist/Draft.css";

const NoticeDetail = (props) => {
  const { data } = props;
  const dispatch = useDispatch();

  const userAgent = checkMobile();
  const contentData = data?.content;

  const blocksFromHTML = convertFromHTML(contentData);
  const contentState = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );
  const editorState = EditorState.createWithContent(contentState);

  const unescapedHtml = contentData.replace(/&quot;/g, '"');

  const HtmlRenderer = ({ html }) => (
    <div dangerouslySetInnerHTML={{ __html: unescapedHtml }} />
  );

  const returnClassName = (time, files) => {
    if (time && files.length > 0) return "fileAndNew";
    else if (time != true && files.length > 0) return "file";
    else if (time == true && files.length <= 0) return "file";
    else return "";
  };
  const isNewNotice = (time) => {
    const oneWeekAgo = new Date();
    const targetTime = new Date(time);
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    // 현재 시간과 일주일 전의 시간 비교
    if (targetTime >= oneWeekAgo) {
      //일주일 이내
      return true;
    } else {
      //일주일 초과
      return false;
    }
  };
  const [id, setId] = useState("");

  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const handleDetailToggle = (li) => {
    // "detail open" 상태를 토글하고 해당 상태에 따라 함수 실행
    setIsDetailsOpen(!isDetailsOpen);

    // "detail open"일 경우 실행할 함수
    if (isDetailsOpen) {
      const params = {
        id: li.id,
      };
      dispatch(serviceActions.fetchNoticeCount({ params }));
    }
  };

  // 정규표현식을 사용하여 <p> 태그 내의 텍스트 추출
  const textInsideP = (htmlCode) => {
    // 정규표현식을 사용하여 모든 <p> 태그 내의 텍스트 추출
    const matches = htmlCode.match(/<p>(.*?)<\/p>/g);

    // 각각의 <p> 태그 내의 텍스트를 큰따옴표 제거하고 출력
    const paragraphs = matches.map((match) => {
      const textInsideP = match.replace(/<\/?p>/g, ""); // <p> 및 </p> 태그 제거
      const cleanedText = textInsideP.replace(/&nbsp;/g, ""); // &nbsp; 제거
      return <p key={cleanedText}>{cleanedText}</p>;
    });
    return paragraphs;
  };

  const parseHTML = (htmlString) => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlString, "text/html");

    // 파싱된 DOM 요소를 순회하여 React 엘리먼트로 변환
    const reactElements = Array.from(parsedHtml.body.childNodes).map(
      (node, index) => {
        return <p key={index}>{node.textContent}</p>; // 예시: 간단한 텍스트 요소로 변환
      }
    );

    return reactElements;
  };

  const handleFileDownload = (url) => {
    if (!url) return;
    else {
      if (userAgent == "other" || userAgent == "ios") {
        if (url.endsWith("/")) {
          url = url.slice(0, -1);
        }
        // Extract the last part after the last '/'
        const fileName = url.split("/").pop();
        fetch(url, {
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "http://localhost:3000",
            "Access-Control-Allow-Credentials": true,
          },
        })
          .then((response) => response.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const a = document.createElement("a");
            a.href = url;
            a.download = `${fileName}`; // Change the file name if needed
            a.click();
          })
          .catch((error) => {
            console.error("Error downloading image:", error);
          });
      } else if (window.ReactNativeWebView) {
        const message = { type: "downloadFiles", content: `${url}` };
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      }
    }
  };

  const downloadFileName = (url) => {
    if (!url) return;
    if (url && url.endsWith("/")) {
      url = url.slice(0, -1);
    }
    const fileName = url.split("/").pop();
    return fileName;
  };
  const reactElements = parseHTML(contentData);
  return (
    <details onClick={() => handleDetailToggle(data)}>
      <summary>
        <TitleDiv>
          <TextWarp>
            {isNewNotice(data.time) && <span>NEW</span>}
            <div>
              <FlexBox>
                <h4
                  className={returnClassName(
                    isNewNotice(data.time),
                    data.files
                  )}
                >
                  {data.title}
                </h4>
                {data.files.length > 0 && <IcoFile />}
              </FlexBox>
              <p>{timeChange(data.time)}</p>
            </div>
          </TextWarp>

          <img src={arrow} alt="arrow" />
        </TitleDiv>
      </summary>
      <OepenDiv>
        {/* <>{textInsideP(data.content)}</> */}
        <div className="editor">
          <Editor readOnly editorState={editorState} />
        </div>
        {/* <div>
          <HtmlRenderer html={unescapedHtml} />
        </div> */}
        {data.files.length > 0 && (
          <FileDownload>
            {data.files.map((li, index) => (
              <p onClick={() => handleFileDownload(li)} key={"files" + index}>
                {downloadFileName(li)}
              </p>
            ))}
          </FileDownload>
        )}
      </OepenDiv>
    </details>
  );
};

export default NoticeDetail;
const InquiryListWrap = styled.div`
  li {
    border-radius: 1rem;
    padding: 2rem 1.5rem;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
    background-color: ${({ theme }) => theme.color.white};
    margin-top: 1rem;
    &:nth-of-type(1) {
      margin-top: 0;
    }
  }

  details[open] {
    summary {
      padding-bottom: 2rem;
      img {
        transform: rotate(180deg);
      }
      h4 {
        white-space: wrap;
        line-height: 1.6rem;
      }
    }
  }
`;

const TitleDiv = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  margin-top: 0.2rem;
  h4 {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2rem; /* 100% */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 70vw;
    width: auto;
    &.new {
      max-width: calc(65vw - 2.5rem);
    }
    &.file {
      max-width: calc(65vw - 2.3rem);
    }
    &.fileAndNew {
      max-width: calc(65vw - 4.8rem);
    }
  }
  p {
    font-size: 1rem;
    line-height: 1rem; /* 100% */
    margin-top: 1rem;
  }
`;

const OepenDiv = styled.div`
  border-top: 1px dashed #000;
  padding-top: 2rem;
  p {
    font-size: 1.2rem;
    line-height: 1.4rem; /* 100% */
  }
  .editor {
    font-size: 1.2rem !important;
    line-height: 1.4rem !important;
  }
  ol,
  ul {
    list-style: auto;
  }
`;

const TextWarp = styled.div`
  display: flex;
  span {
    color: #977bff;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2rem; /* 100% */
    margin-right: 1rem;
  }
  svg {
    margin-left: 1rem;
  }
`;
const FileDownload = styled.div`
  margin-top: 2.5rem;
  p {
    cursor: pointer;
    color: ${({ theme }) => theme.color.blue};
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2rem; /* 100% */
    text-decoration-line: underline;
    margin-top: 0.5rem;
  }
`;
